import Axios from "../../../utils/axios";

export const getPrizes = (data) => {
    return (dispatch) => {
        Axios.get("/raffle-prizes", dispatch, "GET_PRIZES", data)
            .then((response) => {
                return response.response.data
            });
    };
};

export const createPrize = (data) => {
    return (dispatch) => {
        return Axios
            .post("/raffle-prize", dispatch, "CREATE_PRIZE", data)
            .then((response) => {
                if (response.response.data.status === "success") {
                    dispatch(getPrizes());
                }
                return response;
            });
    };
};

export const updatePrize = (data) => {
    return (dispatch) => {
        return Axios
            .post("/raffle-prize/" + data.id, dispatch, "UPDATE_PRIZE", data)
            .then((response) => {
                if (response.response.data.status === "success") {
                    const param = {
                        event_id: data.event_id
                    };
                    dispatch(getPrizes(param));
                }
                return response;
            });
    };
};

export const deletePrize = (data) => {
    return (dispatch) => {
        return Axios
            .delete("/raffle-prize/" + data.id, dispatch, "DELETE_PRIZE")
            .then((response) => {
                if (response.response.data.status === "success") {
                    const param = {
                        event_id: data.event_id
                    };
                    dispatch(getPrizes(param));
                }
                return response;
            });
    };
};